import { Modal } from '@xefi/x-react/modal';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import Image from 'next/image';
import { useState } from 'react';
import type { Media } from '@/models/media';

type ImageVariant = 'question' | 'answer';

type QuestionImageProps = {
   media?: Media;
   variant?: ImageVariant;
};

const imageSize: Record<ImageVariant, string> = {
   question: 'w-[140px] h-[90px]',
   answer: 'w-[70px] h-[70px]',
};

export const QuestionImage = ({
   media,
   variant = 'answer',
}: QuestionImageProps) => {
   const [isModalOpen, setIsModalOpen] = useState(false);

   if (!media) return <div className={imageSize[variant]} />;

   const { original_url, file_name } = media;

   return (
      <>
         <div
            className={mergeTailwindClasses(
               'relative z-90 ml-auto flex cursor-pointer items-center justify-center overflow-hidden rounded-md',
               imageSize[variant],
            )}
         >
            <Image
               fill
               src={original_url}
               alt={file_name}
               style={{ objectFit: 'cover' }}
               unoptimized={true}
               onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  setIsModalOpen(true);
               }}
            />
         </div>
         <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title={file_name}
            className='min-w-[65vw]'
            footer={null}
         >
            <div className='relative h-[60vh] w-[60vw]'>
               <Image
                  src={original_url}
                  fill
                  style={{ objectFit: 'contain' }}
                  alt={file_name}
                  unoptimized={true}
               />
            </div>
         </Modal>
      </>
   );
};
